import { ValueOf } from '../utilities/types';

const languages = {
  SV: 'sv',
  EN: 'en',
  DE: 'de',
} as const;

export type Languages = ValueOf<typeof languages>;

export const languagesChoices = [
  { id: languages.EN, name: 'English' },
  { id: languages.SV, name: 'Swedish' },
  { id: languages.DE, name: 'German' },
];

export default languages;
